import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import * as constants from '../../../app/shared/globalcontants';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import * as appApiResources from '../../shared/globalcontants';

@Injectable()
export class LocalTranslationService implements TranslateLoader {

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private httpService: HttpRequestService){}
   
    /**
   * @method getTranslation()
   * @param event;
   * @description emits language throught the app 
   */
    getTranslation(): Observable<any> {
    try {
            const translations = new BehaviorSubject(undefined);   
            translations.next(JSON.parse(localStorage.getItem(constants.LanguageJson)))      
            return translations;
        } catch (error) {
            console.log(error);            
        }   
    }
    
  /**
   * @method loadTranslationFromAPi(lang)
   * @param lang;
   * @description calls the api inorder to get language json 
   */
    // async loadTranslationFromAPi( lang = null ) {  
    // try {
    //         const GetCurrentLanguage = ( lang !== null ) ? lang : localStorage.getItem(constants.SelectedLanguage)
    //         const GetCurrentVersion = localStorage.getItem(constants.CurrentVersion)
    //         localStorage.setItem(constants.SelectedLanguage, GetCurrentLanguage);
    //         const activeDeviceDetail = JSON.parse(localStorage.getItem('activeDeviceDetail'));
    //         const apiEndPoint="/usermgmt/api/Login/GetLanguage"
    //         let params= {
    //             "UserId": activeDeviceDetail?.UserId || 0,
    //             "LanguageCode": GetCurrentLanguage,
    //             "Version": ( GetCurrentVersion === 'null' || GetCurrentVersion === null ) ? null : GetCurrentVersion,
    //             "Group": "Mobile"
    //         }
        
    //    let res = await this.httpService.postHttpRequest(apiEndPoint, params).toPromise()
    //     if (res) {
    //         if (res.LanguageFile) {
    //             if (res.LanguageFile) {
    //                 localStorage.setItem(constants.LanguageJson, res.LanguageFile);
    //                 localStorage.setItem(constants.CurrentVersion, res.CurrentVersion);
    //                 localStorage.setItem(constants.SelectedLanguage, res.LanguageCode);
    //                 this.translate.use(res.LanguageCode);
    //             }
    //             }else{
    //                 this.translate.use(constants.DefaultLanguage);  
    //             }
    //          }
    //          return res;
    //     } catch (error) {
    //         console.log(error);                        
    //     }       
    // }
}